import { css } from '@emotion/react'

type CableColorCircleProps = {
  color?: [string] | [string, string]
  size?: number
  label?: string
}

/**
 * CableColorCircle - Displays a simple colored circle or gradient circle
 * @param {[string] | [string, string]} color - Single color or array of two colors for diagonal gradient
 * @param {number} size - The diameter of the circle in pixels
 * @param {string} label - The label for the circle (used for accessibility)
 * @returns A styled div representing the cable color
 */
export const CableColorCircle = ({ color = ['#000000'], size = 18, label }: CableColorCircleProps) => {
  const backgroundStyle =
    color.length === 2 ? { backgroundImage: `linear-gradient(135deg, ${color[0]}, ${color[1]})` } : { backgroundColor: color[0] }

  return (
    <div css={{ position: 'relative', minWidth: size, minHeight: size }} title={label}>
      <div css={[styles.dot, backgroundStyle, { minWidth: size, minHeight: size }]} />
      <div css={[styles.border, { minWidth: size, minHeight: size }]} />
    </div>
  )
}

const styles = {
  dot: css({
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '50%',
    display: 'inline-block',
  }),
  border: css({
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: '50%',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: 'rgba(0, 0, 0, 0.1)',
  }),
}

export default CableColorCircle
